{
  "SuperWord_negative": [
    "Mehr Punkte, erwähnen Sie [[word]] mit Selbstvertrauen!",
    "Volltreffer! Sagen Sie [[word]] für einen klasse Anruf.",
    "Bessere Performance: Verwenden Sie [[word]] für Bonuspunkte!",
    "Für eine tolle Atmosphäre: [[word]] erwähnen!",
    "Extrapunkte! Verwenden Sie [[word]] in Gesprächen.",
    "Ihre Geheimwaffe: [[word]]",
    "Vergessen Sie nicht auch mal [[word]] zu erwähnen.",
    "Punkten Sie, erwähnen Sie [[word]] in jedem Gespräch!",
    "[[word]] ist der Schlüssel um Erwartungen zu übertreffen!",
    "Binden Sie [[word]] in jedes Gespräch ein!"
  ],
  "SuperWord_positive": [
    "Glückwunsch! Sie haben [[word]] konstant verwendet!",
    "Sie sammeln viele Punkte mit [superwords]!",
    "Super! Sie verwenden [[word]] in jedem Gespräch!",
    "Gute Arbeit bei der Verwendung von [[word]]!",
    "Gute Arbeit! Sie werten Gespräche mit [[word]] auf!",
    "Gute Arbeit! Erwartungen werden mit [[word]] übertroffen!",
    "Gut gemacht! Sie haben extra Punkte mit [[word]] gesammelt!",
    "Gut gemacht! Sie haben viele Punkte mit [[word]] gesammelt!",
    "Klasse, [[word]] wurde in Gesprächen eingebunden!",
    "Beständige Arbeit bei der Verwendung von [[word]]!"
  ],
  "DoNotSayRate_negative": [
    "Vermeiden Sie [[word]] für optimale Ergebnisse.",
    "Lassen Sie [[word]] weg, für bessere Ergebnisse.",
    "Schließen Sie [[word]] aus, für bessere Performance.",
    "Umschiffen Sie [[word]] in jeder Konversation.",
    "Für positive Auswirkung, eliminieren Sie [[word]].",
    "Lassen Sie [[word]] aus, bleiben Sie positiv!",
    "Tipp: Lassen Sie [[word]] weg, für einen positiven Anruf!",
    "Schließen Sie [[word]] für einen erfolgreichen Anruf aus.",
    "Überspringen Sie [[word]], für eine bessere Leistung.",
    "Verbessern Sie sich: Kein [[word]], für den Erfolg"
  ],
  "DoNotSayRate_positive": [
    "Gratulation! Sie haben die Nicht-Sagen-Wörter vermieden!",
    "Gut gemacht! Nicht-Sagen-Wörter wurden kaum erwähnt!",
    "Super Arbeit! Nicht-Sagen-Wörter wurden selten erwähnt!",
    "Super! Nicht-Sagen-Wörter kamen kaum vor!",
    "Ausgezeichnet! Nicht-Sagen-Wörter wurden kaum erwähnt!",
    "Alles verlief reibungslos und ohne Nicht-Sagen-Wörter!",
    "Gute Arbeit! Sie haben weniger Nicht-Sagen-Wörter erwähnt!",
    "Sie haben Nicht-Sagen-Wörter selten verwendet! Weiter so!",
    "Erwartungen erfüllt: Weniger Nicht-Sagen-Wörter verwendet!",
    "Super! Nicht viele Nicht-Sagen-Wörter wurden erwähnt!"
  ],
  "SpeechRate_negative_fast": [
    "Sprechen Sie langsamer für einen für einen erfolgreichen Anruf!",
    "Langsameres Sprechen für bessere Anrufergebnisse.",
    "Sprechen Sie langsamer, für eine bessere Konversation.",
    "Langsamere Geschwindigkeit verspricht bessere Ergebnisse.",
    "Sprechen Sie langsamer, für effektivere Anrufe."
  ],
  "SpeechRate_negative_slow": [
    "Achten Sie auf die Sprechgeschwindigkeit, langsamer ist besser.",
    "Erhöhen Sie das Tempo für dynamische, effektive Gespräche.",
    "Ein höheres Tempo verbessert die Interaktion.",
    "Sprechen Sie etwas schneller, für eine bessere Wirkung.",
    "Sprechen Sie schneller, für klarere und effektivere Anrufe."
  ],
  "SpeechRate_positive": [
    "Gute Arbeit! Ihr Sprechtempo ist perfekt!",
    "Erstaunlich! Sie sprechen in einem perfekten Tempo!",
    "Ihr Sprechtempo ist genau richtig! Weiter so!",
    "Ihr Sprechtempo ist perfekt! Weiter so!",
    "Sie haben die Sprechgeschwindigkeit unter Kontrolle!"
  ],
  "DoSayRate_negative": [
    "Verwenden Sie [[word]], um optimale Ergebnisse zu erzielen.",
    "Denken Sie an [[word]], für bessere Anrufergebnisse.",
    "Versuchen Sie [[word]] zu verwenden, für bessere Performance.",
    "Verwenden Sie [[word]] in jedem Gespräch.",
    "Verwenden Sie [[word]] für eine positive Wirkung.",
    "Denken Sie an [[word]], bleiben Sie positiv!",
    "Tipp: [[word]] verwenden, für einen positiven Anruf.",
    "Achtung! Verwenden Sie [[word]] für einen erfolgreichen Anruf.",
    "Verwendung von [[word]] verbessert Ihre Leistung.",
    "Verbessern Sie sich: Mit [[word]] zum Erfolg!"
  ],
  "DoSayRate_positive": [
    "Gratulation! Sie halten sich an die Sagen-Wörter!",
    "Gute Arbeit! Die Sagen-Wörter wurden oft erwähnt!",
    "Tolle Arbeit! Sie haben viele Sagen-Wörter verwendet!",
    "Gut gemacht! Sie haben oft Sagen-Wörter erwähnt!",
    "Ausgezeichnet! Sie haben oft Sagen-Wörter erwähnt!"
  ]
}